import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";

import { verifyLoginAction } from "dataStore/auth";
import { getCall_v2 } from "services";

function OAuthRedirectHandler() {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAccessToken = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const authId = params.get("auth-id");

        // For all environments except PROD: If the token is present directly in the URL, log in immediately.
        if (process.env.REACT_APP_ENV !== "PROD") {
          const directToken = params.get("token");
          if (directToken) {
            dispatch(verifyLoginAction({ value: true, token: directToken }));
            return; // No need to call API
          }
        }

        // Normal process: fetch token using authId
        const { data } = await getCall_v2(
          `/auth2-service/auth/outlook/retrieve-access-token?auth-id=${authId}`,
        );

        if (data?.success) {
          dispatch(verifyLoginAction({ value: true, token: data?.token }));
        }
      } catch (error) {
        console.error("Failed to retrieve access token:", error);
      }
    };

    fetchAccessToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
}

export default OAuthRedirectHandler;
